import { SelectListItem } from './select-property'

export const Options_DataSource: SelectListItem[] = [
    { value: "AK", text: "AAP PLS DB" ,group :"Data View"},
    { value: "HI", text: "CN CSS DB",group :"Data View" },
    { value: "HI", text: "TW DSS DB",group :"Data View" },
    { value: "HI", text: "GIM DB",group :"Data View" },
    { value: "AK", text: "AAP PLS Folder" ,group :"File Folder"},
    { value: "HI", text: "CN CSS Folder",group :"File Folder" },
    { value: "HI", text: "TW DSS Folder",group :"File Folder" },
    { value: "AK", text: "AAP PLS FTP" ,group :"FTP"},
    { value: "HI", text: "CN CSS FTP",group :"FTP" },
    { value: "HI", text: "TW DSS FTP",group :"FTP" }
];
